import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import './index.layout.scss'

type LayoutProps = {
  size?: number
}

export const IndexLayout = defineComponent<LayoutProps>({
  name: 'SvgIconLayout',
  props: DefineComponentProps<LayoutProps>(['size']),
  inheritAttrs: false,
  setup(props, { slots, attrs }) {
    return () => (
      <div
        {...attrs}
        class={classNames('svg-icon-layout', attrs.class as string)}
        style={props.size && props.size > 0 ? { '--svg-icon-size': `${props.size}px` } : undefined}
      >
        {slots.default?.()}
      </div>
    )
  },
})

export default IndexLayout
